export enum BaseRoutes {
  INITIAL = '',
}
